module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/permissao-negada/permissao-negada.component.css
// module id = ./src/app/permissao-negada/permissao-negada.component.css
// module chunks = main